import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted } from 'vue'
  import SVGRenderer from '@/components/common/SVGRenderer.vue'
  import useIcons from '@/composables/useIcons'
  import useBreakpoint from '@/composables/useBreakpoint'
  import HTMLRenderer from '@/components/common/HTMLRenderer.vue'
  import type { PropType } from 'vue'
  import type { Answer } from '@/services/interfaces/QuizQuestion'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TestResultItem',
  props: {
    questionTitle: {
      type: String,
      required: true,
    },
    answersInQuestion: {
      type: Array as PropType<Answer[]>,
      required: true,
    },
  },
  emits: ['correct-answer'],
  setup(__props, { emit }) {

const props = __props;

  
  
  const { isMobileDevice } = useBreakpoint()
  const { checkmark, checkmarkIconMobile, crossDanger, wrongAnswerIcon, checkedCircle } = useIcons()

  const getCheckmarkIcon = computed((): string => {
    return isMobileDevice.value ? checkmarkIconMobile.value : checkmark.value
  })

  const allCorrectAnswers = computed((): Answer[] => {
    return props.answersInQuestion.filter((el) => el.isCorrect)
  })

  const checkAllAnswersCorrect = computed((): boolean => {
    return allCorrectAnswers.value.length === selectedCorrectAnswers.value.length
  })

  const selectedCorrectAnswers = computed((): Answer[] => {
    return props.answersInQuestion.filter((el) => el.isCorrect && el.selected)
  })

  const unChosenCorrectAnswers = computed((): Answer[] => {
    return props.answersInQuestion.filter((el) => el.isCorrect && !el.selected)
  })

  const selectedWrongAnswers = computed((): Answer[] => {
    return props.answersInQuestion.filter((el) => el.selected && !el.isCorrect)
  })

  onMounted(() => {
    emit('correct-answer', checkAllAnswersCorrect.value)
  })

return { __sfc: true,props, emit, isMobileDevice, checkmark, checkmarkIconMobile, crossDanger, wrongAnswerIcon, checkedCircle, getCheckmarkIcon, allCorrectAnswers, checkAllAnswersCorrect, selectedCorrectAnswers, unChosenCorrectAnswers, selectedWrongAnswers, computed, onMounted, SVGRenderer, useIcons, useBreakpoint, HTMLRenderer }
}

})